__turbopack_context__.v({
  "actions": "Banner-module-scss-module__xw5kdW__actions",
  "banner": "Banner-module-scss-module__xw5kdW__banner",
  "content": "Banner-module-scss-module__xw5kdW__content",
  "description": "Banner-module-scss-module__xw5kdW__description",
  "logo": "Banner-module-scss-module__xw5kdW__logo",
  "title": "Banner-module-scss-module__xw5kdW__title",
});
